const GoogleAnalytics = () => {
  console.warn(
    'The block canalplus.block.tracking.google_analytics.header is deprecated'
  );
  return null;
};

export default GoogleAnalytics;
